import { render, staticRenderFns } from "./ExternalPanel.vue?vue&type=template&id=6a177466&scoped=true&"
import script from "./ExternalPanel.vue?vue&type=script&lang=js&"
export * from "./ExternalPanel.vue?vue&type=script&lang=js&"
import style0 from "./ExternalPanel.vue?vue&type=style&index=0&id=6a177466&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a177466",
  null
  
)

export default component.exports